//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DebugBlock from "../../items/DebugBlock"
import {windVane} from '../../utils/tmallGenius'
import {tutorialRoute} from '../../utils/tutorialRoute'
import TopMenu from './topMenu.vue'
import DeviceList from './deviceLIst/Index.vue'
//
export default {
  components: {DeviceList, TopMenu, DebugBlock},
  data() {
    return {
      isAddDevAccess: true,
    }
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("设备列表")
    next()
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {
    //检查是否需要进行导向的跳转
    tutorialRoute.move()
    // 检测sdk版本
    windVane.sdkVersionCheck()
    this.getAndSaveCurrentWifiToSession()
  },
  methods: {
    /*------------------------------------------- 自定义方法 -------------------------------------------------------*/
    /*  获取并保存当前wifi
    * */
    getAndSaveCurrentWifiToSession() {
      windVane.getCurrentWifi().then(res => {
        if (res && res.indexOf("HomeMate_AP") < 0) {
          //非设备发出的wifi，保存
          sessionStorage.setItem("firstWifi", res)
        }
      })
    },
    /*------------------------------------------- 绑定方法 -------------------------------------------------------*/
    /*  点击去升级app链接
    * */
    updateAppClick() {
      windVane.toUpdateApp()
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Index.vue